import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import { H5 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MC0655_LIMITS } from 'pricing-pages-lib/constants/MC0655Limits';
import LimitCardProgressBar from './LimitCardProgressBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LimitCard = ({
  limit
}) => {
  const {
    limitName
  } = limit;
  if (!MC0655_LIMITS[limitName]) return null;
  return /*#__PURE__*/_jsx(UICardWrapper, {
    className: "padding-all-8",
    children: /*#__PURE__*/_jsxs(UICardSection, {
      style: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
      },
      children: [/*#__PURE__*/_jsx(H5, {
        className: "m-bottom-2",
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.heading`
        })
      }), /*#__PURE__*/_jsx(LimitCardProgressBar, {
        limit: limit
      }), /*#__PURE__*/_jsx("p", {
        style: {
          flex: 1
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.description`
        })
      }), /*#__PURE__*/_jsx("small", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `ebxInterstitialPage.mc0655LimitUsageSection.${limitName}.upgrade`,
          options: {
            newLimit: MC0655_LIMITS[limitName].starterLimit
          }
        })
      })]
    })
  });
};
export default LimitCard;